module.exports = __webpack_public_path__ + "static/media/screen3.cb10ac60.png";